export enum FeatureFlag {
  // General
  InlineMenu = 'InlineMenu',
  // Account
  AccountRoute = 'AccountRoute',
  AccountTsAndCsBanner = 'AccountTsAndCsBanner',
  AccountTsAndCsBannerUseMahLink = 'AccountTsAndCsBannerUseMahLink',
  AccountTsAndCsApply = 'AccountTsAndCsApply',
  // View Balance
  ViewBalanceRoute = 'ViewBalanceRoute',
  ViewBalanceDownloadLatestStatementCard = 'ViewBalanceDownloadLatestStatementCard',
  ViewBalancePriceAdjustmentCard = 'ViewBalancePriceAdjustmentCard',
  ViewBalanceLastTransactionCard = 'ViewBalanceLastTransactionCard',
  ViewBalanceShowPaymentNotice = 'ViewBalanceShowPaymentNotice',
  ViewBalanceQuickLinks = 'ViewBalanceQuickLinks',
  ViewBalancePendingQuotes = 'ViewBalancePendingQuotes',
  ViewBalanceCurrencyConversion = 'ViewBalanceCurrencyConversion',
  ViewBalanceAccountDetails = 'ViewBalanceAccountDetails',
  ViewBalancePaymentType = 'ViewBalancePaymentType',
  // Billing Explained
  BillingExplainedRoute = 'BillingExplainedRoute',
  // Monthly Statements
  MonthlyStatementsRoute = 'MonthlyStatementsRoute',
  // Payment Methods
  UpdatePaymentMethodsRoute = 'UpdatePaymentMethodsRoute',
  // Amount to pay
  AmountToPayRoute = 'AmountToPayRoute',
  // Payments
  ShowPaymentMinimumAmountNotice = 'ShowPaymentMinimumAmountNotice',
  BlockLesothoPayments = 'BlockLesothoPayments',
  SwitchToDebitOrderSuccessScreen = 'SwitchToDebitOrderSuccessScreen',
  // Landing
  LandingLinkCard = 'LandingLinkCard',
  LandingExploreCard = 'LandingExploreCard',
  LandingActivateCard = 'LandingActivateCard',
  ShowLandingCards = 'ShowLandingCards',
  // Dashboard
  DashboardRoute = 'DashboardRoute',
  DashboardViewingRoute = 'DashboardViewingRoute',
  DashboardInternetRoute = 'DashboardInternetRoute',
  DashboardInsuranceRoute = 'DashboardInsuranceRoute',
  DashboardInactiveRoute = 'DashboardInactiveRoute',
  DashboardAnnouncementBanner = 'DashboardAnnouncementBanner',
  DashboardSafetyRoute = 'DashboardSafetyRoute',
  DashboardQuickLinks = 'DashboardQuickLinks',
  DashboardFilterBar = 'DashboardFilterBar',
  DashboardTabViews = 'DashboardTabViews',
  DashboardPendingQuotes = 'DashboardPendingQuotes',
  DashboardPaymentReminderPopup = 'DashboardPaymentReminderPopup',
  DashboardPaymentReminderAnnouncement = 'DashboardPaymentReminderAnnouncement',
  DashboardContractExpirationBanner = 'DashboardContractExpirationBanner',
  DashboardGenericPopupCampaigns = 'DashboardGenericPopupCampaigns',
  // Transaction History
  TransactionHistoryRoute = 'TransactionHistoryRoute',
  TransactionHistoryCalenderSelection = 'TransactionHistoryCalenderSelection',
  TransactionHistoryFilterBar = 'TransactionHistoryFilterBar',
  TransactionHistoryTableHeaderCard = 'TransactionHistoryTableHeaderCard',
  // Products
  ProductsRoute = 'ProductsRoute',
  SubscriptionsRoute = 'SubscriptionsRoute',
  SubscriptionViewingRoute = 'SubscriptionViewingRoute',
  SubscriptionInactiveRoute = 'SubscriptionInactiveRoute',
  SubscriptionPendingRoute = 'SubscriptionPendingRoute',
  SubscriptionFilterBar = 'SubscriptionFilterBar',
  SubscriptionTabViews = 'SubscriptionTabViews',
  SubscriptionLinkPackageSA = 'SubscriptionLinkPackageSA',
  SubscriptionLinkPackageMAH = 'SubscriptionLinkPackageMAH',
  SelectManageRoute = 'SelectManageRoute',
  SelectViewingRoute = 'SelectViewingRoute',
  LinkPackageQuoteBreakdown = 'LinkPackageQuoteBreakdown',
  BoxOfficeRoute = 'BoxOfficeRoute',
  XtraView = 'XtraView',
  HolidayHomeRoute = 'HolidayHomeRoute',
  UseSubscriptionLayout = 'UseSubscriptionLayout',
  UseDStvMahIcon = 'UseDStvMahIcon',
  ShowReconnectAsPayNow = 'ShowReconnectAsPayNow',
  DisableShowmaxDisconnect = 'DisableShowmaxDisconnect',
  DowngradesAndSaves = 'DowngradesAndSaves',
  CancelPackageChangeSchedule = 'CancelPackageChangeSchedule',
  SubscriptionUpsized = 'SubscriptionUpsized',
  // Fix Error
  FixErrorRoute = 'FixErrorRoute',
  FixErrorForm = 'FixErrorForm',
  UseFixErrorV2 = 'UseFixErrorV2',
  ShowNotListedOption = 'ShowNotListedOption',
  FixErrorUseLiveChat = 'FixErrorUseLiveChat',
  // Offers
  OffersRoute = 'OffersRoute',
  // Activate
  ActivateRoute = 'ActivateRoute',
  // AllProducts
  AllProductsRoute = 'AllProductsRoute',
  // Rewards
  PremiumRoute = 'PremiumRoute',
  RewardsRoute = 'RewardsRoute',
  WhatIsRewardsRoute = 'WhatIsRewardsRoute',
  AvailableRewardsRoute = 'AvailableRewardsRoute',
  EarnMoreStarsRoute = 'EarnMoreStarsRoute',
  CompetitionsRoute = 'CompetitionsRoute',
  RewardsHistoryRoute = 'RewardsHistoryRoute',
  DetailedRewardSummary = 'DetailedRewardSummary',
  RewardsStayConnectedCTA = 'RewardsStayConnectedCTA',
  RewardsActiveProductsCTA = 'RewardsActiveProductsCTA',
  RewardsSelfServiceCTA = 'RewardsSelfServiceCTA',
  RewardsWatchTimeCTA = 'RewardsWatchTimeCTA',
  RewardsPremiumTier = 'RewardsPremiumTier',
  RewardsPremiumCoinsOnlySummary = 'RewardsPremiumCoinsOnlySummary',
  RewardsPremiumExclusiveCompetitions = 'RewardsPremiumExclusiveCompetitions',
  // Profile
  ProfileRoute = 'ProfileRoute',
  ProfileUpdate = 'ProfileUpdate',
  ProfilePreferencesRoute = 'ProfilePreferencesRoute',
  ProfileRewardsCard = 'ProfileRewardsCard',
  ProfilePreferences = 'ProfilePreferences',
  ProfilePostalAddress = 'ProfilePostalAddress',
  ProfilePicture = 'ProfilePicture',
  ProfileDataRequest = 'ProfileDataRequest',
  ProfileDataRequestTEMP = 'ProfileDataRequestTEMP',
  ProfileOptionalEmail = 'ProfileOptionalEmail',
  ProfileUpdateOTP = 'ProfileUpdateOTP',
  // Safety
  SafetyRoute = 'SafetyRoute',
  // Other
  DevTools = 'DevTools',
  ScheduledMaintenancePanel = 'ScheduledMaintenancePanel',
  UnexpectedMaintenancePanel = 'UnexpectedMaintenancePanel',
  // Menu
  MenuProfileCard = 'MenuProfileCard',
  MenuAmountToPayCard = 'MenuAmountToPayCard',
  // Insurance
  InsurancePolicyUpdateAnnouncementBanner = 'InsurancePolicyUpdateAnnouncementBanner',
  InternetRoute = 'InternetRoute',
  InsuranceRoute = 'InsuranceRoute',
  InsuranceFuneralCoverFamilyPlans = 'InsuranceFuneralCoverFamilyPlans',
  InsuranceFuneralCoverPersonal = 'InsuranceFuneralCoverPersonal',
  RewardsPremiumStatusRoute = 'RewardsPremiumStatusRoute',
  RewardsWhatIsPremiumRoute = 'RewardsWhatIsPremiumRoute',
  // Inbox
  InboxRoute = 'InboxRoute',
  // Customer
  LinkCustomerWithIdentityNumber = 'LinkCustomerWithIdentityNumber',
  UseGenexSurveys = 'UseGenexSurveys',
  UseMAHGenexDemographics = 'UseMAHGenexDemographics',
  // Actions
  ActionRoute = 'ActionRoute',
  ProductDisconnection = 'ProductDisconnection',
  ShowAllVasProducts = 'ShowAllVasProducts',
  BypassReconnections = 'BypassReconnections',
  UseDPPPayment = 'UseDPPPayment',
  UsePayAtExternalPayment = 'UsePayAtExternalPayment',
  UsePayAtRedirectPayment = 'UsePayAtRedirectPayment',
  UseRapydRedirectPayment = 'UseRapydRedirectPayment',
  UseRapydEmbeddedPayment = 'UseRapydEmbeddedPayment',
  UseDirectLinkPayment = 'UseDirectLinkPayment',
  UseMomentPayment = 'UseMomentPayment',
  UseMomentCheckoutPayment = 'UseMomentCheckoutPayment',
  // Actions (detailed)
  ActionFeatureActivate = 'ActionFeatureActivate',
  ActionFeatureActivateEPL = 'ActionFeatureActivateEPL',
  ActionFeatureLinkPackage = 'ActionFeatureLinkPackage',
  ActionFeatureChangePackage = 'ActionFeatureChangePackage',
  ActionFeatureChangeDishlessPackage = 'ActionFeatureChangeDishlessPackage',
  ActionFeatureDashboardChangePackage = 'ActionFeatureDashboardChangePackage',
  ActionFeatureReconnectPackage = 'ActionFeatureReconnectPackage',
  ActionFeatureReconnectDishlessPackage = 'ActionFeatureReconnectDishlessPackage',
  ActionFeatureDisconnectPackage = 'ActionFeatureDisconnectPackage',
  ActionFeatureDisconnectDishlessPackage = 'ActionFeatureDisconnectDishlessPackage',
  ActionFeatureCancelShowmax = 'ActionFeatureCancelShowmax',
  ActionFeatureCancelBritbox = 'ActionFeatureCancelBritbox',
  ActionFeatureMonthlyToBundle = 'ActionFeatureMonthlyToBundle',
  ActionFeatureStreamMonthlyToBundle = 'ActionFeatureStreamMonthlyToBundle',
  ActionFeatureStreamRenewBundle = 'ActionFeatureStreamRenewBundle',
  ActionFeatureRecontractBundle = 'ActionFeatureRecontractBundle',
  ActionFeatureRedeemVoucher = 'ActionFeatureRedeemVoucher',
  ActionFeatureSwitchToStream = 'ActionFeatureSwitchToStream',
  ActionFeatureGetQuote = 'ActionFeatureGetQuote',
  ActionFeatureCaptureBundle = 'ActionFeatureCaptureBundle',
  ActionFeatureCreateXtraview = 'ActionFeatureCreateXtraview',
  ActionFeatureBreakXtraview = 'ActionFeatureBreakXtraview',
  ActionFeatureInsureDecoder = 'ActionFeatureInsureDecoder',
  ActionFeatureCancelInsurance = 'ActionFeatureCancelInsurance',
  ActionFeatureViewInsurancePolicy = 'ActionFeatureViewInsurancePolicy',
  ActionFeatureViewLinkProduct = 'ActionFeatureViewLinkProduct',
  ActionFeatureClearErrorCode = 'ActionFeatureClearErrorCode',
  ActionFeatureViewLinked = 'ActionFeatureViewLinked',
  ActionFeatureProductHighlights = 'ActionFeatureProductHighlights',
  ActionFeatureOtherAddOns = 'ActionFeatureOtherAddOns',
  ActionFeatureExtraStream = 'ActionFeatureExtraStream',
  ActionFeatureWatchNow = 'ActionFeatureWatchNow',
  ActionFeatureManageBeneficiaries = 'ActionFeatureManageBeneficiaries',
  ActionFeatureManageMembers = 'ActionFeatureManageMembers',
  ActionFeatureAddBeneficiary = 'ActionFeatureAddBeneficiary',
  ActionFeatureCancelDecoderInsurance = 'ActionFeatureCancelDecoderInsurance',
  ActionFeatureSubmitClaim = 'ActionFeatureSubmitClaim',
  ActionFeatureWhatsCovered = 'ActionFeatureWhatsCovered',
  ActionFeaturePolicyDocuments = 'ActionFeaturePolicyDocuments',
  ActionFeatureFuneralPolicyDocuments = 'ActionFeatureFuneralPolicyDocuments',
  ActionFeatureSubscriptionPolicyDocuments = 'ActionFeatureSubscriptionPolicyDocuments',
  ActionFeatureDebtWaiverPolicyDocuments = 'ActionFeatureDebtWaiverPolicyDocuments',
  ActionFeatureDecoderPolicyDocuments = 'ActionFeatureDecoderPolicyDocuments',
  ActionFeatureDeviceCarePlan = 'ActionFeatureDeviceCarePlan',
  ActionFeatureCodeOfConduct = 'ActionFeatureCodeOfConduct',
  ActionFeatureComplaintsPolicy = 'ActionFeatureComplaintsPolicy',
  ActionFeatureSpeakToAnAgent = 'ActionFeatureSpeakToAnAgent',
  ActionFeatureRelocateFibre = 'ActionFeatureRelocateFibre',
  ActionFeatureCancelFibreService = 'ActionFeatureCancelFibreService',
  UseGhostAcceptQuote = 'UseGhostAcceptQuote',
  UseChangePackageGhostAcceptQuote = 'UseChangePackageGhostAcceptQuote',
  SubscriptionActivationLink = 'SubscriptionActivationLink',
  DashboardActivationLink = 'DashboardActivationLink',
  // Internet FLTE Actions
  ActionFeatureTopUP = 'ActionFeatureTopUP',
  ActionFeatureSetInternetSpeedLimit = 'ActionFeatureSetInternetSpeedLimit',
  ActionFeatureDataTransfer = 'ActionFeatureDataTransfer',
  ActionFeatureUpdateDeviceName = 'ActionFeatureUpdateDeviceName',
  ActionFeatureLocationUpdate = 'ActionFeatureLocationUpdate',
  ActionFeatureBalanceEnquiry = 'ActionFeatureBalanceEnquiry',
  ActionFeatureGetSimStatus = 'ActionFeatureGetSimStatus',
  ActionFeatureChangeInternetPackage = 'ActionFeatureChangeInternetPackage',
  ActionFeatureInternetDisconnect = 'ActionFeatureInternetDisconnect',
  ActionFeatureInternetReconnect = 'ActionFeatureInternetReconnect',
  // VAS
  HasShowmax = 'HasShowmax',
  HasShowmaxPL = 'HasShowmaxPL',
  HasBritbox = 'HasBritbox',
  HasNetflix = 'HasNetflix',
  HasDisney = 'HasDisney',
  HasMobileStream = 'HasMobileStream',
  LinkPackageAddCTA = 'LinkPackageAddCTA',
  LinkPackageEmailStep = 'LinkPackageEmailStep',
  // LiveChat
  LiveChat = 'LiveChat',
  LiveChatLegacy = 'LiveChatLegacy',
  LiveChatIFrame = 'LiveChatIFrame',
  // WelcomeCarousel
  WelcomePopup = 'WelcomePopup',
  BrandMissMatchPopup = 'BrandMissMatchPopup',
  // HaptikBot
  UseHaptikBot = 'UseHaptikBot',
  ErrorNoticeChatToAgent = 'ErrorNoticeChatToAgent',
  // Payments
  ShowGeneralPaymentErrors = 'ShowGeneralPaymentErrors',
  ShowPaymentValidationErrors = 'ShowPaymentValidationErrors',
  ShowPaymentStatusErrors = 'ShowPaymentStatusErrors',
  ShowTimeoutAsSuccess = 'ShowTimeoutAsSuccess',
  ShowPaymentTransactionRef = 'ShowPaymentTransactionRef',
  UseMarketMinMaxValidations = 'UseMarketMinMaxValidations',
  AllowCompactAmountToPayEdit = 'AllowCompactAmountToPayEdit',
  AllowStandardAmountToPayEdit = 'AllowStandardAmountToPayEdit',
  UseTokenPaymentOnContract = 'UseTokenPaymentOnContract',
  // Other
  MahSmartcardSurnameLogin = 'MahSmartcardSurnameLogin',
  AllowGotvInterface = 'AllowGotvInterface',
  UserBasedMenuConfig = 'UserBasedMenuConfig',
  UserBasedUrlLocale = 'UserBasedUrlLocale',
  ShowSmartcardAsIUC = 'ShowSmartcardAsIUC',
  HardcodedAnywhereStreams = 'HardcodedAnywhereStreams',
  MonthlyToBundlePaymentMethodSelection = 'MonthlyToBundlePaymentMethodSelection',
  UseSubscriptionLayoutForBundleSwitch = 'UseSubscriptionLayoutForBundleSwitch',
  UseMonthlyToBundleAltLayout = 'UseMonthlyToBundleAltLayout',
  ShowShowmaxDisconnectSurvey = 'ShowShowmaxDisconnectSurvey',
  // Recurring Payment
  RecurringPaymentRoute = 'RecurringPaymentRoute',
}
